import React, { useEffect, useState } from "react"
import InformationCircle from "../common/Icons/InformationCircle"
import Popover from "@mui/material/Popover"
import Typography from "@mui/material/Typography"
import { uuidv4 } from "../Utils/helpers"
import { classNames } from "../Utils/helpers"
import { mapListToFormOptions } from "./helper"
import QkHelp from "./QkHelp"
import { useLocation } from "react-router-dom"
import { Button } from "@mui/material"
import { DOMESTIC_SCHEMA_KEYS } from "../Utils/constants"

export default function QkAdditiveRadio({
  data,
  handleChange,
  values,
  fieldError,
}) {
  const location = useLocation()
  if (
    data?.key === DOMESTIC_SCHEMA_KEYS.additive_value_show &&
    !values?.ins_data &&
    values?.ins_number
  ) {
    data = {
      ...data,
      items: ["Additive Name"],
      default: "Additive Name",
    }
  }

  const radio_group = uuidv4()

  const items_per_row = data.itemsPerRow ?? 3

  let list = mapListToFormOptions(data)

  const [anchorEl, setAnchorEl] = useState(null)

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  const id = open ? "simple-popover" : undefined
  const error = fieldError && !values[data.key] && data.required

  return (
    <>
      <div
        className={`inline-flex items-center ${
          data.disabled ? "opacity-50 cursor-not-allowed text-[grey]" : ""
        }`}
      >
        <p className={`px-4 ${data.styles}`}>
          {data.title} {data.required && "*"}
        </p>
        {data.help && <QkHelp helpText={data.help} />}
      </div>

      <div className={`grid grid-cols-${items_per_row} gap-2 px-4`}>
        {list?.map(({ key, value }) => (
          <div className="inline-flex items-center my-1" key={key}>
            {!data.hideRadio ? (
              <label
                className={`inline-flex items-center my-1 text-sm font-bold ${
                  data.disabled
                    ? "opacity-50 cursor-not-allowed text-opacity-50"
                    : ""
                } ${data.styles}`}
              >
                <input
                  name={radio_group}
                  type="radio"
                  value={key}
                  disabled={data?.disabled}
                  checked={values[data.key] === key}
                  onChange={(e) => handleChange(e.target.value)}
                  className={`focus:outline-none focus:ring-0 h-4 w-4 checked:bg-orange-500 checked:focus:bg-orange-500 focus:bg-orange-500 border-bordergray mr-1 font-bold ${
                    data.disabled ? "opacity-50 cursor-not-allowed" : ""
                  } ${error ? "border-red-500" : ""}`}
                />

                {value}
              </label>
            ) : (
              <button
                key={key}
                onClick={() => handleChange(key)}
                disabled={data.disabled}
                className={classNames(
                  `inline-flex rounded-lg overflow-clip border-4 ${
                    data.disabled &&
                    "cursor-not-allowed opacity-50 text-opacity-50"
                  }`,
                  values[data.key] === key && "border-orange-500",
                  values[data.key] !== key && "border-transparent opacity-60",
                )}
              >
                {value}
              </button>
            )}
          </div>
        ))}
      </div>
    </>
  )
}
